import { useEffect } from "react";

export default function SEO({ title, description }) {
    useEffect(() => {
        if (title) document.title = `${title} · Muviarts Official`;
        else document.title = "Muviarts Official";
        if (description) {
            let el = document.querySelector('meta[name="description"]');
            if (!el) { el = document.createElement("meta"); el.name = "description"; document.head.appendChild(el); }
            el.setAttribute("content", description);
        }
        return () => { document.title = "Muviarts Official"; };
    }, [title, description]);
    return null;
}
